import type { CategoryItem } from "web_myplann/Portfolio/Types/portfolioCategory";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";
import { getMonthlyPayment } from "web_myplann/Shared/Utils/getMonthlyPayment";

export const calculateMonthlyPayment = (item: CategoryItem): number | null => {
	if (item.kind !== PortfolioItemKind.Portfolio) {
		return null;
	}

	const { payment, installment, paymentFrequency } = item.data;
	return getMonthlyPayment(payment ?? installment, paymentFrequency) ?? null;
};
